import {
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentFactory,
  ComponentRef,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ModalService, ComponentCreationParameters } from './modal.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HotkeysService } from 'src/app/services/hotkeys.service';

@Component({
    selector: 'app-modal-container',
    templateUrl: './modal-container.component.html',
    styleUrls: ['./modal-container.component.scss'],
    standalone: false
})
export class ModalContainerComponent implements OnDestroy, OnInit {
  @ViewChild('modalContainer', { read: ViewContainerRef })
  protected modalContainer: ViewContainerRef;
  public contentComponentFactory$: Observable<ComponentCreationParameters<any>>;
  private componentRef: ComponentRef<any>;
  private hotKey;
  public isOpen: boolean = false;

    constructor(private modalService: ModalService, private hotkeys: HotkeysService) {
        
    this.contentComponentFactory$ = this.modalService.componentCreationParameters.pipe(
      tap((componentCreationParams) => {
        if (componentCreationParams)
          this.open(
            componentCreationParams.componentFactory,
            componentCreationParams.onInit
          );
        else this.closeModal();
      })
    );
  }
    ngOnInit(): void {
    this.hotKey = this.hotkeys.addShortcut({ keys: 'esc' }).subscribe(() => {
      this.modalService.close();
    });
  }

  ngOnDestroy(): void {
    if (this.componentRef) this.componentRef.destroy();
    if(this.hotKey) this.hotKey.unsubscribe();
  }

  private open(
    componentFactory: ComponentFactory<any>,
    onInit: (component: any) => void
  ) {
    // Opening the same kind of panel again -- clicking a second row while the panel
    // is already up -- swaps its contents in place. Clearing and rebuilding would
    // destroy the view and leave the panel blank while the new one fetches, which
    // reads as the panel closing and reopening.
    const reuseInstance =
      this.isOpen &&
      this.componentRef &&
      this.componentRef.componentType === componentFactory.componentType;

    if (!reuseInstance) {
      this.modalContainer.clear(); // destroys the previous component with it
      this.componentRef = this.modalContainer.createComponent(componentFactory);
    }

    if (onInit) onInit(this.componentRef.instance);

    // A reused instance has already run its lifecycle, so the new inputs would
    // otherwise never be read. Re-running ngOnInit reloads it for the new row.
    if (reuseInstance && typeof this.componentRef.instance.ngOnInit === 'function') {
      this.componentRef.instance.ngOnInit();
    }

    this.isOpen = true;
  }

  public close() {
    this.modalService.close();
  }

  private closeModal() {
    if (this.modalContainer) this.modalContainer.clear();
    if (this.componentRef) this.componentRef.destroy();
    if(this.hotKey) this.hotKey.unsubscribe();
    this.isOpen = false;
  }
}
